import { useElevation, Button } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import classNames from 'classnames';

import useNavigation from 'Hooks/useNavigation';
import { useSaveTaskBundle } from '../../hooks/useSaveTaskBundle';
import { useTaskBundleDraft } from '../../providers/TaskBundleProvider/TaskBundleProvider';
import { TaskBundleMode } from '../../types';
import { isEditingMode } from '../../helpers';

type TaskBundleFooterProps = {
  mode: TaskBundleMode;
};

const TaskBundleFooter: React.FC<TaskBundleFooterProps> = ({ mode }) => {
  const { onSave } = useSaveTaskBundle();
  const { goToBackPage } = useNavigation();
  const { selectors } = useTaskBundleDraft();

  const isEditing = isEditingMode(mode);
  const footerElevation = useElevation(1);

  return (
    <div
      className={classNames(
        'w-full flex justify-end py-2 px-12',
        footerElevation
      )}
    >
      <Button variant='tertiary' className='mr-4' onClick={goToBackPage}>
        {intl.get('CANCEL')}
      </Button>
      <Button
        disabled={!selectors.canSave}
        className={classNames({ 'cursor-not-allowed': !selectors.canSave })}
        onClick={onSave}
        data-cy='save-task-bundle_button'
        data-testid='build-bundle-submit-button'
      >
        {isEditing
          ? intl.get('SETTINGS_PAGE.TASK_BUNDLE_PAGE.UPDATE')
          : intl.get('SAVE')}
      </Button>
    </div>
  );
};

export default TaskBundleFooter;
